module.exports = __webpack_public_path__ + "img/idram.5768ec49.png";